module.exports = __webpack_public_path__ + "94ef2da016bb8db779224f663b8b079e.png";